export default "__VITE_ASSET__CqacUe0u__"